/* eslint-disable operator-linebreak */
/* eslint-disable import/no-cycle */
/* eslint camelcase: 0 */

// dependencies
import _forOwn from 'lodash/forOwn';
import { device_pixel_ratio } from 'javascript-retina-detect';

// constants
import {
  DESTINATION_CHARGER_MARKER,
  RESOURCE_BASE_URL,
  SUPERCHARGER_MARKER,
} from './Constants';

// helpers
import MapUtils from './MapUtils';
import MapWindow from './MapWindow';

// origin pin
// import originPinSml2x from '../images/markers/origin-pin-sml@2x.png';
import originPinMed2x from '../images/markers/origin-pin-med@2x.png';
// import originPinLrg2x from '../images/markers/origin-pin-lrg@2x.png';

// destination pin
import destinationPinSml2x from '../images/markers/destination-pin-sml@2x.png';
// import destinationPinMed2x from '../images/markers/destination-pin-med@2x.png';
// import destinationPinLrg2x from '../images/markers/destination-pin-lrg@2x.png';

// supercharger dot
import superchargerSml from '../images/markers/supercharger-sml.png';
import superchargerMed from '../images/markers/supercharger-med.png';
import superchargerLrg from '../images/markers/supercharger-lrg.png';
import superchargerSml2x from '../images/markers/supercharger-sml.svg'; // TODO update paths.
import superchargerMed2x from '../images/markers/supercharger-med.svg'; // TODO update paths.
import superchargerLrg2x from '../images/markers/supercharger-lrg.svg'; // TODO update paths.

// supercharger pins
import superchargerPinSml2x from '../images/markers/supercharger-pin-sml@2x.png';
import superchargerPinMed2x from '../images/markers/supercharger-pin-med@2x.png';
import superchargerPinLrg2x from '../images/markers/supercharger-pin-lrg@2x.png';

// selected supercharger pins
import superchargerPinSelectedSml2x from '../images/markers/supercharger-pin-selected-sml@2x.png';
import superchargerPinSelectedMed2x from '../images/markers/supercharger-pin-selected-med@2x.png';
import superchargerPinSelectedLrg2x from '../images/markers/supercharger-pin-selected-lrg@2x.png';

// destination chargers
import destinationChargerSml2x from '../images/markers/destinationcharger-sml@2x.png';
import destinationChargerMed2x from '../images/markers/destinationcharger-med@2x.png';
// import destinationChargerLrg2x from '../images/markers/destinationcharger-lrg@2x.png';

// selected destination chargers
import destinationChargerSelectedSml2x from '../images/markers/destinationcharger-selected-sml@2x.png';
import destinationChargerSelectedMed2x from '../images/markers/destinationcharger-selected-med@2x.png';
// import destinationChargerSelectedLrg2x from '../images/markers/destinationcharger-selected-lrg@2x.png';

class MapMarkers {
  constructor() {
    this.markers = {};

    // origin markers
    this.originSizes = [];

    // destination markers
    this.destinationSizes = [];

    // red dots
    this.chargerSizes = [];

    // red supercharger pins
    this.superchargerSizes = [];

    // black "selected" supercharger pins
    this.selectedSuperchargerSizes = [];

    // destination chargers
    this.destinationChargerSizes = [];

    // black "selected" destination charger icons
    this.selectedDestinationChargerSizes = [];
  }

  /**
   * @description Set Origin & stopover marker properties
   *
   * @return {void}
   */
  constructOriginMarkers() {
    const { google } = window;

    // origin markers
    // NOTE: make sure to input the width and height / 2 so if the image is 10x10 then input 5x5
    // const sml = { path: originPinSml2x, width: 5, height: 5 };
    const med = { path: originPinMed2x, width: 10, height: 10 };
    // const lrg = { path: originPinLrg2x, width: 20, height: 20 };
    this.originSizes = [
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
    ];
  }

  /**
   * @description Creates origin & stopover map marker
   *
   * @param {Object} place - Marker location details
   *
   * @return {void}
   */
  setOriginMarker(place) {
    const { map } = window;
    const size = map.getZoom();
    if (this.originSizes.length === 0) this.constructOriginMarkers();
    this.createMapMarker(place, this.originSizes[size]);
  }

  /**
   * @description Set Destination marker properties
   *
   * @return {void}
   */
  constructDestinationMarkers() {
    const { google } = window;

    // origin markers
    // NOTE: make sure to input the width and height / 2 so if the image is 10x10 then input 5x5
    const sml = { path: destinationPinSml2x, width: 15, height: 20 };
    // const med = { path: destinationPinMed2x, width: 30, height: 40 };
    // const lrg = { path: destinationPinLrg2x, width: 45, height: 60 };
    this.destinationSizes = [
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
    ];
  }

  /**
   * @description Creates destination map marker
   *
   * @param {Object} place - Marker location details
   *
   * @return {void}
   */
  setDestinationMarker(place) {
    const { map } = window;
    const size = map.getZoom();
    if (this.destinationSizes.length === 0) this.constructDestinationMarkers();
    this.createMapMarker(place, this.destinationSizes[size]);
  }

  /**
   * @description Set Supercharger network marker properties
   *
   * @return {void}
   */
  constructChargerNetworkMarker() {
    if (device_pixel_ratio() > 1) {
      this.chargerSizes = [
        `${RESOURCE_BASE_URL}${superchargerSml2x}`,
        `${RESOURCE_BASE_URL}${superchargerSml2x}`,
        `${RESOURCE_BASE_URL}${superchargerSml2x}`,
        `${RESOURCE_BASE_URL}${superchargerSml2x}`,
        `${RESOURCE_BASE_URL}${superchargerSml2x}`,
        `${RESOURCE_BASE_URL}${superchargerSml2x}`,
        `${RESOURCE_BASE_URL}${superchargerMed2x}`,
        `${RESOURCE_BASE_URL}${superchargerMed2x}`,
        `${RESOURCE_BASE_URL}${superchargerMed2x}`,
        `${RESOURCE_BASE_URL}${superchargerMed2x}`,
        `${RESOURCE_BASE_URL}${superchargerMed2x}`,
        `${RESOURCE_BASE_URL}${superchargerMed2x}`,
        `${RESOURCE_BASE_URL}${superchargerMed2x}`,
        `${RESOURCE_BASE_URL}${superchargerLrg2x}`,
        `${RESOURCE_BASE_URL}${superchargerLrg2x}`,
        `${RESOURCE_BASE_URL}${superchargerLrg2x}`,
        `${RESOURCE_BASE_URL}${superchargerLrg2x}`,
        `${RESOURCE_BASE_URL}${superchargerLrg2x}`,
        `${RESOURCE_BASE_URL}${superchargerLrg2x}`,
        `${RESOURCE_BASE_URL}${superchargerLrg2x}`,
        `${RESOURCE_BASE_URL}${superchargerLrg2x}`,
        `${RESOURCE_BASE_URL}${superchargerLrg2x}`,
        `${RESOURCE_BASE_URL}${superchargerLrg2x}`,
      ];
    } else {
      this.chargerSizes = [
        superchargerSml,
        superchargerSml,
        superchargerSml,
        superchargerSml,
        superchargerSml,
        superchargerSml,
        superchargerMed,
        superchargerMed,
        superchargerMed,
        superchargerMed,
        superchargerMed,
        superchargerMed,
        superchargerMed,
        superchargerLrg,
        superchargerLrg,
        superchargerLrg,
        superchargerLrg,
        superchargerLrg,
        superchargerLrg,
        superchargerLrg,
        superchargerLrg,
        superchargerLrg,
        superchargerLrg,
      ];
    }
  }

  /**
   * @description Creates supercharger map marker
   *
   * @param {Object} place - Marker location details
   * @param {integer} zoomLevel - Current Map zoom level for sizing the icon
   * @param {string} content - Additional content to append to API results
   * @param {boolean} isMobile - If the user is on a handheld device
   * @param {string} e - to distinguish between supercharger and destination charger
   *
   * @return {void}
   */
  setChargerNetworkMarker(place, zoomLevel, content, isMobile, type, errorMsg) {
    if (this.chargerSizes.length === 0) {
      this.constructChargerNetworkMarker();
    }

    this.createMapMarker(
      place,
      this.chargerSizes[zoomLevel],
      content,
      isMobile,
      type,
      errorMsg,
    );
  }

  /**
   * @description Set Supercharger marker (pin) properties
   *
   * @return {void}
   */
  constructorSuperchargerPinMarkers() {
    const { google } = window;

    // red supercharger pins
    // NOTE: make sure to input the width and height / 2 so if the image is 10x10 then input 5x5
    let sml = { path: superchargerPinSml2x, width: 15, height: 20 };
    let med = { path: superchargerPinMed2x, width: 30, height: 40 };
    let lrg = { path: superchargerPinLrg2x, width: 45, height: 60 };
    this.superchargerSizes = [
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: lrg.path,
        scaledSize: new google.maps.Size(lrg.width, lrg.height),
      },
      {
        url: lrg.path,
        scaledSize: new google.maps.Size(lrg.width, lrg.height),
      },
      {
        url: lrg.path,
        scaledSize: new google.maps.Size(lrg.width, lrg.height),
      },
    ];

    // black "selected" supercharger pins
    // NOTE: make sure to input the width and height / 2 so if the image is 10x10 then input 5x5
    sml = { path: superchargerPinSelectedSml2x, width: 15, height: 20 };
    med = { path: superchargerPinSelectedMed2x, width: 30, height: 40 };
    lrg = { path: superchargerPinSelectedLrg2x, width: 45, height: 60 };
    this.selectedSuperchargerSizes = [
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: lrg.path,
        scaledSize: new google.maps.Size(lrg.width, lrg.height),
      },
      {
        url: lrg.path,
        scaledSize: new google.maps.Size(lrg.width, lrg.height),
      },
      {
        url: lrg.path,
        scaledSize: new google.maps.Size(lrg.width, lrg.height),
      },
    ];
  }

  /**
   * @description Set Destination charger marker properties
   *
   * @return {void}
   */
  constructDestinationChargerMarkers() {
    const { google } = window;

    // destination chargers
    // NOTE: make sure to input the width and height / 2 so if the image is 10x10 then input 5x5
    let sml = { path: destinationChargerSml2x, width: 12, height: 12 };
    let med = { path: destinationChargerMed2x, width: 24, height: 24 };
    // let lrg = { path: destinationChargerLrg2x, width: 40, height: 40 };
    this.destinationChargerSizes = [
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
    ];

    // black "selected" destination charger pins
    // NOTE: make sure to input the width and height / 2 so if the image is 10x10 then input 5x5
    sml = { path: destinationChargerSelectedSml2x, width: 12, height: 12 };
    med = { path: destinationChargerSelectedMed2x, width: 24, height: 24 };
    // lrg = { path: destinationChargerSelectedLrg2x, width: 40, height: 40 };
    this.selectedDestinationChargerSizes = [
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: sml.path,
        scaledSize: new google.maps.Size(sml.width, sml.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
      {
        url: med.path,
        scaledSize: new google.maps.Size(med.width, med.height),
      },
    ];
  }

  /**
   * @description Creates destination charger map marker
   *
   * @param {Object} place - Marker location details
   * @param {integer} zoomLevel - Current Map zoom level for sizing the icon
   * @param {string} content - Additional content to append to API results
   * @param {boolean} isMobile - If the user is on a handheld device
   * @param {string} chargerType - to distinguish between supercharger and destination charger
   *
   * @return {void}
   */
  setDestinationChargerMarker(
    place,
    zoomLevel,
    content,
    isMobile,
    chargerType,
  ) {
    if (this.destinationChargerSizes.length === 0) {
      this.constructDestinationChargerMarkers();
    }

    this.createMapMarker(
      place,
      this.destinationChargerSizes[zoomLevel],
      content,
      isMobile,
      chargerType,
    );
  }

  /**
   * @description Sets origin or destination map marker
   *
   * @param {Object} place - Location details
   * @param {integer} fieldsLen - Number of places in a users trip
   *
   * @return {void}
   */
  setMapMarker(place, fieldsLen) {
    const { markers } = this;
    const order = Number(place.order);

    if (markers[place.id]) {
      this.updateMapMarker(place, fieldsLen);
    } else if (order === fieldsLen) {
      this.setDestinationMarker(place);
    } else {
      this.setOriginMarker(place);
    }
  }

  /**
   * @description Creates a custom map marker and displays on the Google map
   *
   * @param {Object} place - Location details
   * @param {string} icon - png|svg image
   * @param {string=} content - Optional Additional content to append to API results
   * @param {boolean=} isMobile - If the user is on a handheld device
   * @param {string=} e - Optional to distinguish between supercharger and destination charger
   *
   * @return {void}
   */
  createMapMarker(
    place,
    icon,
    content = false,
    isMobile = false,
    type = false,
    errorMsg = '',
  ) {
    const { google, map } = window;
    const { markers } = this;
    const zoom = map.getZoom();

    if (markers[place.id] || markers[place.trt_id]) {
      return;
    }

    const lat = place.lat || place.location.lat;
    const lng = place.lng || place.location.lng;
    const position = new google.maps.LatLng(lat, lng);
    const marker = new google.maps.Marker({ position, map, icon });

    // store marker in memory
    this.markers[place.id || place.trt_id] = marker;

    if (type) {
      this.markers[place.id || place.trt_id].selected = false;
      this.markers[place.id || place.trt_id].type = type;
    }

    if (typeof content === 'string') {
      // eslint-disable-next-line arrow-parens
      marker.addListener('click', e => {
        // eslint-disable-next-line object-curly-newline
        const params = {
          place,
          position,
          marker,
          content,
          isMobile,
          e,
          errorMsg,
        };

        MapWindow.getChargerDetails(params);
      });
    }

    if (icon === this.originSizes[zoom]) {
      MapUtils.panToMapMarker(position);
    }
  }

  /**
   * @description Toggle selected state of charger icon
   *
   * @param {Object} marker - Map marker object
   * @param {Object} trtLocation - Address details
   * @param {Object} place - Location details
   *
   * @return {void}
   */
  swapIcon({ marker, trtLocation, place }) {
    const { map } = window;
    const zoom = map.getZoom();
    const icon = marker.getIcon();
    if (icon !== this.chargerSizes[zoom]) {
      if (trtLocation) {
        // supercharger
        marker.setIcon(this.selectedSuperchargerSizes[zoom]);
      } else {
        // destination charger
        marker.setIcon(this.selectedDestinationChargerSizes[zoom]);
      }
      this.markers[place.id].selected = true;
    }
  }

  /**
   * @description Toggles a marker from selected state to display it's original icon
   *
   * @return {void}
   */
  resetSelectedMarkers(centerChangedEvtList, boundsChangedEvtList) {
    const { map } = window;
    const zoom = map.getZoom();
    const { markers } = this;

    // Clear previous event handlers.
    if (centerChangedEvtList) {
      window.google.maps.event.removeListener(centerChangedEvtList);
    }
    if (boundsChangedEvtList) {
      window.google.maps.event.removeListener(boundsChangedEvtList);
    }

    _forOwn(markers, (value, key) => {
      if (
        markers[key].selected === true &&
        markers[key].type === SUPERCHARGER_MARKER
      ) {
        this.markers[key].setIcon(this.superchargerSizes[zoom]);
      } else if (
        markers[key].selected === true &&
        markers[key].type === DESTINATION_CHARGER_MARKER
      ) {
        this.markers[key].setIcon(this.destinationChargerSizes[zoom]);
      }
      this.markers[key].selected = false;
    });
  }

  /**
   * @description Sets the icon for a map marker and will display it on the map if not already
   *              displayed
   *
   * @param {Object} place - Location details
   * @param {integer} place.id - Unique identifier
   * @param {integer} place.lat - Latitude
   * @param {integer} place.lng - Longitude
   * @param {integer} fieldsLen - Number of places in a users trip
   *
   * @return {void}
   */
  updateMapMarker(place, fieldsLen) {
    const order = Number(place.order);
    const { markers } = this;
    const { google, map } = window;
    const zoom = map.getZoom();

    if (!markers[place.id].map) markers[place.id].setMap(map);

    const coords = new google.maps.LatLng(place.lat, place.lng);
    markers[place.id].setPosition(coords);

    if (order === fieldsLen - 1) {
      if (this.destinationSizes.length === 0) {
        // eslint-disable-next-line nonblock-statement-body-position
        this.constructDestinationMarkers();
      }
      markers[place.id].setIcon(this.destinationSizes[zoom]);
    } else {
      markers[place.id].setIcon(this.originSizes[zoom]);
    }

    MapUtils.panToMapMarker(markers[place.id].getPosition());
  }

  /**
   * @description Updates the icons of multiple charger markers
   *
   * @param {Array} chargers - markers to be updated
   *
   * @return {void}
   */
  updateChargerIconSize(chargers) {
    const { map } = window;
    const { markers } = this;
    const zoom = map ? map.getZoom() : 13;

    let i = 0;
    const chargersLen = chargers.length;
    for (i; i < chargersLen; i += 1) {
      // if the marker is not displayed on the map
      if (!markers[chargers[i].id].map) markers[chargers[i].id].setMap(map);

      // set it's icon
      markers[chargers[i].id].setIcon(this.chargerSizes[zoom]);
    }
  }

  /**
   * @description Updates the icons of multiple markers on the map
   *
   * @param {Array} fields - Markers to be updated
   *
   * @return {void}
   */
  updateTripMarkers(fields) {
    let i = 0;
    const fieldsLen = fields.length;
    for (i; i < fieldsLen; i += 1) {
      if (fields[i].lat && fields[i].lng) {
        this.updateMapMarker(fields[i], fieldsLen);
      }
    }
  }

  /**
   * @description Displays a marker on the map and appropriate icon variant depending on the state
   *
   * @param {Array} destinationChargers - Markers to be updated
   *
   * @return {void}
   */
  updateRoutechargerMarkers(routeChargers) {
    const { map } = window;
    const zoom = map.getZoom();
    const { markers } = this;

    if (this.superchargerSizes.length === 0) {
      // eslint-disable-next-line nonblock-statement-body-position
      this.constructorSuperchargerPinMarkers();
    }

    let i = 0;
    const chargersLen = routeChargers.length;
    for (i; i < chargersLen; i += 1) {
      const charger = routeChargers[i];
      const chargerID = Number(charger.trt_id);
      try {
        if (!markers[chargerID].map) markers[chargerID].setMap(map);

        if (markers[chargerID].selected === true) {
          markers[chargerID].setIcon(this.selectedSuperchargerSizes[zoom]);
        } else {
          markers[chargerID].setIcon(this.superchargerSizes[zoom]);
        }
      } catch (e) {
        // if locations API goes down create a faux supercharger marker
        this.createMapMarker(
          routeChargers[i],
          this.superchargerSizes[zoom],
          {},
          false,
          SUPERCHARGER_MARKER,
        );
      }
    }
  }

  /**
   * @description Displays a marker on the map and appropriate icon variant depending on the state
   *
   * @param {Array} destinationChargers - Markers to be updated
   *
   * @return {void}
   */
  updateDestinationChargerMarkers(destinationChargers) {
    const { map } = window;
    const zoom = map.getZoom();
    const { markers } = this;

    let i = 0;
    const chargersLen = destinationChargers.length;
    for (i; i < chargersLen; i += 1) {
      const charger = destinationChargers[i];
      const chargerID = charger.id;
      try {
        // if the marker is not displayed on the map, then display it
        if (!markers[chargerID].map) markers[chargerID].setMap(map);

        // set the appropriate variant of the marker
        if (markers[chargerID].selected === true) {
          markers[chargerID].setIcon(
            this.selectedDestinationChargerSizes[zoom],
          );
        } else {
          markers[chargerID].setIcon(this.destinationChargerSizes[zoom]);
        }
      } catch (e) {
        // console.log('♻');
      }
    }
  }

  /**
   * @description Removes a single map marker from the map
   *
   * @param {Array} marker - Marker to be removed
   * @param {boolean=} hardDelete - Deletes reference to the map marker when true
   *
   * @return {void}
   */
  deleteMapMarker(marker, hardDelete = false) {
    const { markers } = this;
    const id = marker.id || marker.trt_id;
    if (markers[id]) markers[id].setMap(null);
    if (hardDelete) delete markers[id];
  }

  /**
   * @description Removes multiple map markers from the map
   *
   * @param {Array} markers - Markers to be removed
   * @param {boolean=} hardDelete - Deletes reference to the map marker when true
   *
   * @return {void}
   */
  deleteMapMarkers(markers, hardDelete = false) {
    let i = 0;
    const markersLen = markers.length;
    for (i; i < markersLen; i += 1) {
      this.deleteMapMarker(markers[i], hardDelete);
    }
  }
}

export default new MapMarkers();
